import React from 'react';

import { LaunchpadEditor } from 'launchpad/containers/LaunchpadEditor/LaunchpadEditor';

export const LaunchpadApp = () => {
  return <LaunchpadEditor />;
};
